/* eslint-disable  @typescript-eslint/no-explicit-any */
import { SelectItem } from 'primeng/api';

export type NumericEnum = Record<string, string | number>;

export type JsonSchema = Record<string, unknown>;

export function enumValues(enumType: NumericEnum): number[] {
  return Object.values(enumType).filter((value): value is number => typeof value === 'number');
}

export function enumSchema(enumName: string, enumType: NumericEnum, descriptionSuffix = ''): JsonSchema {
  const values = enumValues(enumType);
  const labels = values.map((value) => `${value}=${enumType[value]}`).join(', ');

  return {
    type: 'number',
    enum: values,
    description: `${enumName} enum: ${labels}.${descriptionSuffix ? ` ${descriptionSuffix}` : ''}`,
  };
}

export function parseEnumValues<T extends number>(value: unknown, enumType: NumericEnum): T[] | undefined {
  if (!Array.isArray(value)) {
    return undefined;
  }

  const validValues = new Set(enumValues(enumType));
  const values = value.filter((item): item is T => typeof item === 'number' && validValues.has(item));

  return values.length ? values : undefined;
}

export class EnumExtension {
  static getLabelAndValues<T extends number>($enum: any): SelectItem[] {
    return EnumExtension.getNames($enum).map((n) => ({ label: n, value: $enum[n] as T }));
  }

  static getBoolenLabelAndValues(): SelectItem[] {
    return [
      { label: 'true', value: true },
      { label: 'false', value: false },
    ];
  }

  static getNames(e: any): string[] {
    return EnumExtension.getObjValues(e).filter((v) => typeof v === 'string') as string[];
  }

  static getValues<T extends number>(e: any): T[] {
    return EnumExtension.getObjValues(e).filter((v) => typeof v === 'number') as T[];
  }

  private static getObjValues(e: any): (number | string)[] {
    return Object.keys(e).map((k) => e[k]);
  }

  static getMultiValues<T extends number>($enum: any, multiRole: T): Array<T> {
    const userRoles = Array<T>();

    if (multiRole) {
      let code = (multiRole as number).valueOf();
      EnumExtension.getNames($enum)
        .map((n) => ({ label: n, value: $enum[n] as T }))
        .sort((a, b) => 0 - (a.value > b.value ? 1 : -1))
        .forEach((x) => {
          if (code - x.value >= 0 && (x.value > 0 || !userRoles.length)) {
            code = code - x.value;
            userRoles.push(x.value);
          }
        });
    }
    return userRoles;
  }
}
